import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ion-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslateModule],
})
export class ErrorComponent {
  private activatedRoute = inject(ActivatedRoute);
  statusCode = this.activatedRoute.snapshot.data['statusCode'] as number;
}
